import { AdapterBase, RunResponseType } from "./AdapterBase";
export class InterviewBotAdapter extends AdapterBase {
    runResponseType() {
        return RunResponseType.INTERVIEW_BOT;
    }
}
